import React from 'react';
import { Button, Divider, Select, Space } from 'antd';
import SortValueModal from './SortValueModal';

const Desktop = ({ viewModel }) => {
  const {
    value,
    option,
    valueLabelMap,
    sortModalOpen,
    draftOrder,
    handleSelectChange,
    openSortModal,
    applySortOrder,
    closeSortModal,
    reorderInDraft,
  } = viewModel;

  return (
    <>
      <Select
        mode='tags'
        style={{ width: '100%' }}
        placeholder={option.title}
        value={value}
        onChange={handleSelectChange}
        options={(option.values || []).map((v) => ({ value: v.id, label: v.title }))}
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider style={{ margin: '8px 0' }} />
            <Space direction='vertical' size={4} style={{ width: '100%', padding: '0 8px 8px' }}>
              <div style={{ color: '#8c8c8c' }}>Nhấn Enter để tạo thêm giá trị mới</div>
              <Button
                size='small'
                type='link'
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={openSortModal}
                disabled={(value || []).length < 2}
              >
                Sắp xếp giá trị đã chọn
              </Button>
            </Space>
          </>
        )}
      />

      <SortValueModal
        open={sortModalOpen}
        draftOrder={draftOrder}
        valueLabelMap={valueLabelMap}
        onCancel={closeSortModal}
        onApply={applySortOrder}
        onReorder={reorderInDraft}
      />
    </>
  );
};

export default Desktop;
